/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface InboundSourceSummary
 */
export interface InboundSourceSummary {
    /**
     * 
     */
    sender_name?: string;
    /**
     * 
     */
    sender_number?: string;
    /**
     * 
     */
    receiver_number?: string;
    /**
     * 
     */
    receiver_name?: string;
    /**
     * Facility of the receiving fax line. An unassigned item (facility_ids = []) can only be sent to Screener here.
     */
    receiver_facility_id?: string;
    /**
     * 
     */
    received_at: Date;
}

/**
 * Check if a given object implements the InboundSourceSummary interface.
 */
export function instanceOfInboundSourceSummary(value: object): value is InboundSourceSummary {
    if (!('received_at' in value) || value['received_at'] === undefined) return false;
    return true;
}

export function InboundSourceSummaryFromJSON(json: any): InboundSourceSummary {
    return InboundSourceSummaryFromJSONTyped(json, false);
}

export function InboundSourceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundSourceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'sender_name': json['sender_name'] == null ? undefined : json['sender_name'],
        'sender_number': json['sender_number'] == null ? undefined : json['sender_number'],
        'receiver_number': json['receiver_number'] == null ? undefined : json['receiver_number'],
        'receiver_name': json['receiver_name'] == null ? undefined : json['receiver_name'],
        'receiver_facility_id': json['receiver_facility_id'] == null ? undefined : json['receiver_facility_id'],
        'received_at': (json['received_at'] == null ? json['received_at'] : parseDateTime(json['received_at'])),
    };
}

export function InboundSourceSummaryToJSON(json: any): InboundSourceSummary {
    return InboundSourceSummaryToJSONTyped(json, false);
}

export function InboundSourceSummaryToJSONTyped(value?: InboundSourceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sender_name': value['sender_name'],
        'sender_number': value['sender_number'],
        'receiver_number': value['receiver_number'],
        'receiver_name': value['receiver_name'],
        'receiver_facility_id': value['receiver_facility_id'],
        'received_at': value['received_at'] == null ? value['received_at'] : serializeDateTime(value['received_at']),
    };
}

